import { z } from "zod";

export const resetPasswordSchema = (t: (arg: string) => string) =>
  z.object({
    newPassword: z
      .string()
      .min(8)
      .max(20)
      .regex(/[A-Z]/)
      .regex(/[a-z]/)
      .regex(/[0-9]/)
      .regex(/[!"#'()*+,-./:;<=>?@]/),
    confirmNewPassword: z
      .string()
      .min(8)
      .max(20),
  }).refine((data) => data.newPassword === data.confirmNewPassword, {
    message: "Le password non coincidono",
    path: ["confirmNewPassword"],
  });

export type ResetPasswordType = z.infer<ReturnType<typeof resetPasswordSchema>>;